// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PHeatMapOutlinedSvg from "@fishx/icons-svg/es/asn/PHeatMapOutlined";
import FishxIcon from '../components/FishxIcon';

var PHeatMapOutlined = function PHeatMapOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PHeatMapOutlinedSvg
  }));
};

PHeatMapOutlined.displayName = 'PHeatMapOutlined';
export default React.forwardRef(PHeatMapOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PHeatMapOutlined.js
// module id = 3450
// module chunks = 0